import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface AllroadQuattroSelectedIconProps {
  color?: Color;
}

const AllroadQuattroSelectedIcon: React.FC<AllroadQuattroSelectedIconProps> = ({
  color = COLORS.black,
}) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45038)">
      <path
        d="M8.31005 25.85L5.57006 25.42C4.89006 25.34 3.57006 25.25 3.44006 23.54C3.31006 21.83 3.35009 18.76 4.72009 17.65C6.22054 16.5619 7.91897 15.7773 9.72009 15.34C14.2114 14.321 18.7877 13.7218 23.39 13.55C26.5732 11.6727 29.8509 9.96045 33.2101 8.42001C34.6601 8.00001 44.0601 6.42001 60.1201 8.17001C61.2147 8.27614 62.2984 8.47348 63.3601 8.76001C63.6201 8.85001 70.28 13.55 70.28 13.55C70.6514 13.9455 70.9225 14.4244 71.0704 14.9465C71.2183 15.4685 71.2389 16.0184 71.1301 16.55C71.2201 17.55 71.2201 18.43 71.2201 18.43L72.0701 20.31C72.0701 20.31 71.9901 23.72 70.7101 23.98C69.0801 24.32 67.8001 24.58 66.6101 24.75L8.31005 25.85Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path d="M49.22 24.28L25.22 24.62" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M63.5 23.69C64.0525 24.925 64.1652 26.312 63.8195 27.62C63.4738 28.928 62.6905 30.0781 61.6 30.8789C60.5095 31.6797 59.1776 32.0828 57.8261 32.0211C56.4746 31.9595 55.1851 31.4367 54.172 30.5399C53.159 29.6432 52.4837 28.4265 52.2586 27.0924C52.0334 25.7584 52.272 24.3874 52.9346 23.2079C53.5972 22.0283 54.6439 21.1113 55.9003 20.6095C57.1567 20.1077 58.5471 20.0514 59.84 20.45"
        fill={color}
      />
      <path
        d="M63.5 23.69C64.0525 24.925 64.1652 26.312 63.8195 27.62C63.4738 28.928 62.6905 30.0781 61.6 30.8789C60.5095 31.6797 59.1776 32.0828 57.8261 32.0211C56.4746 31.9595 55.1851 31.4367 54.172 30.5399C53.159 29.6432 52.4837 28.4265 52.2586 27.0924C52.0334 25.7584 52.272 24.3874 52.9346 23.2079C53.5972 22.0283 54.6439 21.1113 55.9003 20.6095C57.1567 20.1077 58.5471 20.0514 59.84 20.45"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M11.12 17.22C10.53 17.22 8.89991 17.31 8.38991 17.39C7.87991 17.47 6.76999 17.73 6.59999 18.07C6.45578 18.4938 6.48449 18.9573 6.67995 19.36C7.53644 19.455 8.40227 19.4247 9.25002 19.27C9.93002 18.67 10.61 18.07 11.25 17.48C11.3 17.39 11.3 17.22 11.12 17.22Z"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M25.22 14.32C25.22 14.32 37.01 13.72 41.62 13.63L64.85 13.12"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M42.05 8.16L40.51 13.72" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M51.36 8.5L54.69 13.37" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M71.5199 14.69H67.59C67.5457 14.6924 67.5038 14.7111 67.4724 14.7425C67.441 14.7738 67.4223 14.8157 67.4199 14.86V15.03C67.6407 15.2958 67.8382 15.5802 68.01 15.88C68.3116 16.2837 68.7308 16.5841 69.21 16.74C69.8341 16.82 70.4659 16.82 71.09 16.74L71.6599 16.66"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M22.85 23.69C23.4004 24.923 23.5119 26.3073 23.1662 27.6125C22.8204 28.9177 22.0381 30.0652 20.9495 30.864C19.8609 31.6627 18.5316 32.0647 17.1828 32.0029C15.8339 31.9411 14.5469 31.4193 13.5359 30.5243C12.5249 29.6293 11.8508 28.4151 11.6259 27.0837C11.4009 25.7523 11.6386 24.384 12.2995 23.2066C12.9603 22.0291 14.0044 21.1134 15.2581 20.6119C16.5117 20.1104 17.8993 20.0532 19.19 20.45"
        fill={color}
      />
      <path
        d="M22.85 23.69C23.4004 24.923 23.5119 26.3073 23.1662 27.6125C22.8204 28.9177 22.0381 30.0652 20.9495 30.864C19.8609 31.6627 18.5316 32.0647 17.1828 32.0029C15.8339 31.9411 14.5469 31.4193 13.5359 30.5243C12.5249 29.6293 11.8508 28.4151 11.6259 27.0837C11.4009 25.7523 11.6386 24.384 12.2995 23.2066C12.9603 22.0291 14.0044 21.1134 15.2581 20.6119C16.5117 20.1104 17.8993 20.0532 19.19 20.45"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45038">
        <rect width="70" height="26" fill="white" transform="translate(3 7)" />
      </clipPath>
    </defs>
  </svg>
);

export default AllroadQuattroSelectedIcon;
